export default function appsFlyerDismissal() {
  if (typeof window === 'undefined') {
    throw new Error('window is not defined');
  }
  if (typeof window?.AF === 'function') {
    window.AF('banners', 'hideBanner');
  }
}
